<template>
  <div>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-card flat rounded="lg" v-else>
      <v-card-title class="body-1 font-weight-bold">Menu inicial</v-card-title>
      <v-card-text>
        <v-row v-if="getAtalhosDispositivo().length > 0">
          <v-col
            xl="2"
            lg="2"
            md="2"
            cols="12"
            v-for="(atalho, i) in getAtalhosDispositivo()"
            :key="i"
          >
            <v-card
              :to="atalho.rota"
              hover
              style="height: 100%"
              rounded="lg"
              outlined
            >
              <v-card-text class="text-center">
                <v-icon :size="isMobile() ? 34 : 30" class="primary--text">{{
                  atalho.icone
                }}</v-icon>
                <p class="mt-3 primary--text font-weight-bold body-2 mb-1">
                  {{ atalho.descricao }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-alert text type="info" v-else>Nenhuma opção disponível</v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  computed: mapState("sistema", ["atalhos"]),
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions("sistema", ["getAtalhosIniciais"]),    
    ...mapGetters("sistema",["device"]),
    getAtalhosDispositivo() {
      var atalhosExibir = [];
      this.atalhos.forEach((atalho) => {        
        if (atalho.dispositivo == 0 || this.device() == atalho.dispositivo) {
          atalhosExibir.push(atalho);
        }
      });
      return atalhosExibir;
    },
    isMobile(){
      return this.$mq == 'sm'
    },    
  },
  async mounted() {
    this.loading = true;
    await this.getAtalhosIniciais();
    this.loading = false;
  },
};
</script>

<style>
</style>